/**
 * React 19 compatibility shim for react-bootstrap 0.33 / react-overlays 0.9.
 *
 * Both ReactDOM.unmountComponentAtNode and ReactDOM.unstable_renderSubtreeIntoContainer
 * were removed in React 19. react-overlays/LegacyPortal (used by Tooltip / Modal portal
 * rendering in react-bootstrap 0.33) requires both at runtime.
 *
 * This file must be imported before any react-bootstrap component renders.
 */
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';

if (!ReactDOM.unmountComponentAtNode) {
  const _roots = new Map();
  const _pendingUnmounts = new Set();

  ReactDOM.unmountComponentAtNode = (container) => {
    const root = _roots.get(container);
    if (root) {
      // React 19 warns if unmount is invoked synchronously during render.
      // Defer to the microtask queue and allow cancellation if re-rendered.
      _pendingUnmounts.add(container);
      Promise.resolve().then(() => {
        if (_pendingUnmounts.has(container) && _roots.get(container) === root) {
          root.unmount();
          _roots.delete(container);
          _pendingUnmounts.delete(container);
        }
      });
      return true;
    }
    return false;
  };

  ReactDOM.unstable_renderSubtreeIntoContainer = (parentComponent, element, container, callback) => {
    let root = _roots.get(container);
    if (!root) {
      root = createRoot(container);
      _roots.set(container, root);
    }
    // If an unmount was queued for this container, keep the root alive.
    _pendingUnmounts.delete(container);
    root.render(element);
    if (callback) {
      Promise.resolve().then(callback);
    }
    return null;
  };
}
